import * as React from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { IftStatusResponse } from "../../../types/components/fundTransfer/ftTypes";
import { toINR } from "../../../service/numberFormat";
import moment from "moment";
import { AddRemClass } from "../../../helper/addRemoveClsOfTgt";
import FtFundsModal, { ftStatsIcon } from "./ftModal";
import { FtCircledIcon } from "../generic/ftCircleOIcon";
import { useQuery } from "../../../service/urlHelper";
import EdButton, { EdLinkButton } from "../../../generic/edButton";
import { jwtToken } from "../../../types/genericTypes";
import { parsedToken } from "../../../service/storageHelper";
import DeviceContext from "../../../service/indentifyDevice";
import { Idevice } from "../../../types/device";

const handleDevice: Idevice = DeviceContext();

export interface IFtModalPayInProps {}

function FtPayinStat(ftresponse: IftStatusResponse) {
	return (
		<>
			{ftresponse && (
				<div
					className={
						"ftModalBody  taCenter mg-t20 " + (ftresponse.status === 200 ? "success" : ftresponse.status === 100 ? "warning" : "failure")
					}
				>
					<FtCircledIcon style={{ width: "125px", height: "125px" }} icon={<i className={ftStatsIcon[ftresponse.status] + " icon"}></i>} />
					{ftresponse.status === 200 ? (
						<>
							<p className="ftStatusMsg mg-t25">Transfer Successful</p>
							<p className="ftTransferdesc">
								₹{toINR(ftresponse.amount, 2)} added to account on {moment(ftresponse.createddate).format("DD MMM YYYY, hh:mm a")}
							</p>
						</>
					) : ftresponse.status === 100 ? (
						<>
							<p className="ftStatusMsg mg-t25">Awaiting Response</p>
							<p className="ftTransferdesc">
								The QR code has timed out. Please complete the transaction if you have already scanned the QR code
							</p>
						</>
					) : ftresponse.status === 0 && ftresponse.paymode === "UPI Intent" ? (
						<>
							<p className="ftStatusMsg mg-t25">Request Timed Out</p>
							<p className="ftTransferdesc">
								{/* The UPI Intent has timed out. Please complete the transaction if you have already scanned the QR code */}
							</p>
						</>
					) : (
						<>
							<p className="ftStatusMsg mg-t25">Transfer Failed</p>
							<p className="ftTransferdesc">
								Failure to add ₹{toINR(ftresponse.amount, 2)} on {moment(ftresponse.createddate).format("DD MMM YYYY, hh:mm a")}
							</p>
						</>
					)}
					{FtTransferDetails(ftresponse)}
					<p className="mg-t25 showDetls">
						<EdButton
							value="Show details"
							btnTyp="blue-link"
							className="showDetls"
							onClick={() => {
								AddRemClass(true, "#ftRespDetails", "show");
							}}
						/>
					</p>
					<div className="ftStatDetails">
						{ftresponse.status === 200 && FtSuccessActionsList()}
						{(ftresponse.status === 0 ||
							ftresponse.status === 100 ||
							(ftresponse.status === "500" && ftresponse.paymode === "UPI Intent")) &&
							FtTimeOutActionsList()}
					</div>
					{ftresponse.status === 500 && (
						<p className={"mg-t25 " + (handleDevice.isMobile ? "mg-b70" : "")}>
							<EdLinkButton value="Retry" btnTyp="primary" className=" cta" LinkHref="/fund-transfer/add-funds" />
						</p>
					)}
				</div>
			)}
		</>
	);
}
export function FtTransferDetails(ftresponse: IftStatusResponse) {
	return (
		<div className="ftStatDetails ftTglDetails" id="ftRespDetails">
			<ul className="transactDetails">
				<li>
					<label className="lbl">Amt Transferred:</label>
					<label className="val">₹{toINR(ftresponse.amount, 2)}</label>
				</li>
				{(ftresponse.paymode === "UPI" || ftresponse.paymode === "UPI Intent") && (
					<li>
						<label className="lbl">UPI id</label>
						<label className="val">{ftresponse.upi}</label>
					</li>
				)}
				<li>
					<label className="lbl">A/C No.</label>
					<label className="val">{ftresponse.accountno}</label>
				</li>
				<li>
					<label className="lbl">Bank Name:</label>
					<label className="val">{ftresponse.bankname}</label>
				</li>
				<li>
					<label className="lbl">{ftresponse.paymode === "UPI Intent" ? "Bank Ref. No:" : "Edelweiss Ref.No "}</label>
					<label className="val">{ftresponse.bankrefno || ftresponse.customrefno || "--"}</label>
				</li>
				{ftresponse.status !== 200 && ftresponse.remarks && (
					<li className="remarks">
						<label className="lbl">Reason</label>
						<label className="val red">{ftresponse.remarks}</label>
					</li>
				)}
			</ul>
		</div>
	);
}

// list of redirections after success full transaction
export function FtSuccessActionsList() {
	const pToken: jwtToken | null = parsedToken();
	return (
		<ul className="ftRedirectLinks taLeft">
			<li>
				<Link to="../place-order">
					<span>Place Order</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
			<li>
				<Link to={"../../limits/" + (pToken && pToken.accType === "CO" ? "comm" : "equity")}>
					<span>Limits</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
			<li>
				<Link to="../add-funds">
					<span>Transfer More Funds</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
		</ul>
	);
}
export function FtTimeOutActionsList() {
	return (
		<ul className="ftRedirectLinks taLeft">
			<li>
				<Link to="../add-funds">
					<span>Transfer More Funds</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
			<li>
				<Link to="../history/eq/added">
					<span>History</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
		</ul>
	);
}
export default function FtModalPayIn(_props: IFtModalPayInProps) {
	const { state } = useParams<{ state: string }>();

	const query = useQuery();
	const history = useHistory();
	//contains transaction callback status

	let ftresponse: IftStatusResponse = JSON.parse("" + (state && ((query.get(state) as unknown) as IftStatusResponse)) + "");
	//resets the query parameters
	window.history.pushState({}, "", window.location.href.split("?")[0]);
	!ftresponse && history.push("/fund-transfer/add-funds");
	return (
		<section className="ftSection">
			{ftresponse && <FtFundsModal status={FtPayinStat(ftresponse)} showLogo={true} showFooter={true} closeLink="/fund-transfer/add-funds" />}{" "}
		</section>
	);
}
